if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.bindEvents();
      }

      bindEvents() {
        const main_wrapper = this.querySelector('.swiper-main-wrapper');
        const product_handle = this.getAttribute('data-product-handle');
        const gridItemWidth = this.getAttribute('data-grid-item-class');
        const rowOf = this.getAttribute('data-row-of');
        const images_size = this.getAttribute('data-image-sizes');
        const enable_quick_add = this.getAttribute('data-quick_add_btn');
        const sliderOptions = this.getAttribute('data-slider-options');

        let promises = [];

        console.log(theme.recentlyViewed.recent, "theme.recentlyViewed.recent");

        // Collect valid recently viewed product handles
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle && handle !== 'undefined' && product_handle !== handle) {
            promises.push(getProductInfo(handle));
          }
        });

        console.log(promises, "promises");

        // If no products to show, display placeholder message
        if (promises.length === 0) {
          const placeholder = document.createElement('div');
          placeholder.className = 'recently-viewed-placeholder';
          placeholder.innerHTML = `
            <p>You haven't viewed any products yet. Browse our
            <a href="/collections/all">best-sellers</a> to get started!</p>`;
          main_wrapper.appendChild(placeholder);
          return;
        }

        // Fetch and render recently viewed products
        Promise.all(promises).then(function (productsHTML) {
          // Filter out null or invalid products
          const validProducts = productsHTML.filter(product => product);

          if (validProducts.length === 0) {
            // If all products are null, show placeholder
            const placeholder = document.createElement('div');
            placeholder.className = 'recently-viewed-placeholder';
            placeholder.innerHTML = `
              <p>You haven't viewed any products yet. Browse our
              <a href="/collections/all">best-sellers</a> to get started!</p>`;
            main_wrapper.appendChild(placeholder);
            return;
          }

          const container = document.createElement('div');
          container.className = 'swiper recently-viewed-swiper';

          const wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';

          // Only append valid products
          validProducts.forEach(function (productHTML) {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = productHTML;
            wrapper.appendChild(slide);
          });

          container.appendChild(wrapper);
          main_wrapper.appendChild(container);
            // 👇 ADD THIS LOGIC
          const navBtns = document.querySelector('.nav-btns'); 

          if (validProducts.length > 4) {
            navBtns.classList.add('active');
          } else {
            navBtns.classList.remove('active');
          }

          // Initialize Swiper if options are provided
          if (sliderOptions) {
            const sliderOptionConfig = JSON.parse(sliderOptions);
            new Swiper(".recently-viewed-swiper", sliderOptionConfig);
          }
        });

        // Fetch product info (from theme cache or via AJAX)
        function getProductInfo(handle) {
          return new Promise(function (resolve, reject) {
            if (!handle || handle === 'null' || handle === 'undefined') {
              resolve(null);
              return;
            }

            if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
              resolve(theme.recentlyViewed.productInfo[handle]);
            } else {
              fetch('/products/' + handle + '?view=recently-viewed-product')
                .then(response => response.text())
                .then(product => {
                  if (product.includes('<!doctype html>')) {
                    resolve(null);
                  } else {
                    resolve(product);
                  }
                })
                .catch(reject);
            }
          });
        }
      }
    }
  );

  // iWish integration
  try {
    if (typeof iWish !== "undefined") {
      setTimeout(() => iWish.checkIwishColl(), 3000);
    }
  } catch (error) {
    // ignore errors
  }
}